
export { AuthRoutes as Auth } from "./src/routes/auth"
export { LicenseRoutes as License } from "./src/routes/license"
export { NewsRoutes as News } from "./src/routes/news"